/** @jsx jsx */
// eslint-disable-next-line
import React, { useEffect, useState } from 'react'
import { css, jsx } from '@emotion/core'
import { FormControl, MenuItem, Select, withStyles } from '@material-ui/core'
// Import moment locales explicitly because they are excluded by default.
import 'moment/dist/locale/es'
import 'moment/dist/locale/pt'
import 'moment/dist/locale/ar'
import 'moment/dist/locale/zh-cn'
import 'moment/dist/locale/ja'
import 'moment/dist/locale/fr'
import 'moment/dist/locale/tr'
import 'moment/dist/locale/pl'
import 'moment/dist/locale/it'
import 'moment/dist/locale/de'
import 'moment/dist/locale/ru'
import 'moment/dist/locale/nl'
import 'moment/dist/locale/he'
import 'moment/dist/locale/ca'
import 'moment/dist/locale/id'
import * as Constants from '../../../constants'
import * as Translations from '../../../translations'
import * as UserLocale from 'get-user-locale'
import store from '../../../store'
import actionTypes from '../../../constants/actionTypes'
import { connect } from 'react-redux'

const styles = {}

styles.languageContainer = css`
  display: flex;
  align-items: flex-end;
  margin: 20px;
  border: 1px solid;
  border-radius: 5px;
  background: #eef5f4;
`

styles.dropdownContainer = css`
  position: relative;
  width: 100%;
`

styles.selectFlag = css`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

styles.selectContainer = css`
  border-radius: 2px;
  background: transparent;
  width: 100%;
  text-align: center;
  height: 40px;
`

styles.selectForm = css`
  height: 40px;
  padding-left: 10px;
`

styles.selectOption = css`
  display: flex;
  align-items: center;
  justify-content: center;
`

styles.languageLabel = css`
  display: flex;
  flex-grow: 1;
  padding-right: 20px;
`

styles.languageIcon = css`
  width: 36px;
`

const CssSelect = withStyles({
  select: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '0px',
    paddingBottom: '0px',
    color: 'black',
    '&:focus': {
      backgroundColor: 'transparent'
    }
  }
})(Select)

function LanguageSelect(props) {
  function onChangeLanguage(event) {
    store.dispatch({ type: actionTypes.UPDATE_LANGUAGE, payload: event.target.value })
  }

  return (
    <div css={styles.languageContainer}>
      <div css={styles.dropdownContainer}>
        <FormControl css={styles.selectContainer}>
          <CssSelect
            disableUnderline
            onChange={onChangeLanguage}
            name="language"
            value={props.language}
            css={styles.selectForm}
          >
            {Object.values(Constants.Languages).map(v => (
              <MenuItem key={v.value} value={v.value} css={styles.selectOption}>
                <span css={styles.languageLabel}>{v.label}</span>
                <img src={v.icon} css={styles.languageIcon} />
              </MenuItem>
            ))}
          </CssSelect>
        </FormControl>
      </div>
    </div>
  )
}

function getLanguageInfo(queryParams) {
  // Read language from local-storage.
  let languageInfo
  const storedLocale = localStorage.getItem('language')
  if (storedLocale) {
    languageInfo = Object.values(Translations).find(v => v.locale === storedLocale)
  }

  // If null, read language from navigator settings.
  if (!languageInfo) {
    const userLocales = UserLocale.getUserLocales()
    for (let i = 0; i < userLocales.length; i += 1) {
      languageInfo = Object.values(Translations).find(v => v.locale === userLocales[i])
      if (languageInfo) {
        break
      }
    }
  }

  // If null, read language from URL params.
  if (!languageInfo) {
    const locale = queryParams.lang || queryParams.language
    languageInfo = Object.values(Translations).find(v => v.locale === locale)

    // If there's no language info in local-storage, save it.
    if (languageInfo) {
      localStorage.setItem('language', locale)
    }
  }

  // If null, use default language.
  if (!languageInfo) {
    languageInfo = Translations.English
  }

  return languageInfo
}

function mapStateToProps(state) {
  return {
    language: state.auth.language
  }
}

export default connect(mapStateToProps)(LanguageSelect)
